import { render, staticRenderFns } from "./historyAnalysis.vue?vue&type=template&id=2ae59f6d&scoped=true&"
import script from "./historyAnalysis.vue?vue&type=script&lang=js&"
export * from "./historyAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./historyAnalysis.vue?vue&type=style&index=0&id=2ae59f6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae59f6d",
  null
  
)

export default component.exports